import { DependenciesInjection } from "app/di/DependencyInjection";
import { ApiDocumentImpl } from "../data/ApiDocumentImpl";
import { IApiDocumentRepository } from "../domain/repositories/IApiDocumentRepository";
import { ApiDocumentUseCase } from "../domain/useCases/ApiDocumentUseCase";
import { ApiDocumentViewModel } from "../presentation/viewModel/ApiDocumentViewModel";
import { ApiDocumentToken } from "./ApiDocumentToken";

export class ApiDocumentInjection {
  static initInjections() {
    DependenciesInjection.register<IApiDocumentRepository>(
      ApiDocumentToken.IApiDocumentRepository,
      ApiDocumentImpl,
      "otherRepo",
    );
    DependenciesInjection.register<ApiDocumentUseCase>(
      ApiDocumentToken.ApiDocumentUseCase,
      ApiDocumentUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<ApiDocumentViewModel>(
      ApiDocumentToken.ApiDocumentViewModel,
      ApiDocumentViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IApiDocumentRepository>(
      ApiDocumentToken.IApiDocumentRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<ApiDocumentUseCase>(
      ApiDocumentToken.ApiDocumentUseCase,
    );
  }

  static getViewModel() {
    return DependenciesInjection.getRepo<ApiDocumentViewModel>(
      ApiDocumentToken.ApiDocumentViewModel,
    );
  }
}
